import axios from 'axios'
import { baseUrl } from './config'

export function getPaymentSystem () {
  return axios.get(`${baseUrl}/payment-systems`)
}

export function changePaymentOrder (id, params) {
  return axios.put(`${baseUrl}/payment-systems/${id}/swap-order`, params)
}

export function updatePaymentLimits (id, params) {
  return axios.put(`${baseUrl}/payment-systems/${id}`, params)
}
